export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8216.9c96a4cb.jpg";